import React, {useContext, useEffect, useState} from 'react';
import {IClientModel} from '../../../src/@interfaces/models/Client/IClientModel';
import {Props} from '../../../src/components/Form/FormField';
import {FormTabsContext} from '../../../src/contexts/FormTabsContext';
import {useLocation} from 'react-router-dom';
import OrdersLoader from './orders/OrdersLoader';

export default function ClientOrdersField<Model extends IClientModel = IClientModel>(props: Props<Model>) {
    const {tabName, model} = props;
    const tabsContext = useContext(FormTabsContext);
    const location = useLocation();
    const [hasBeenShown, setHasBeenShown] = useState(false);
    const ordersAmount = model != null && ('orders_count' in model) ? model.orders_count : 0;

    useEffect(() => {
        if (!tabsContext || !tabName) {
            return;
        }

        tabsContext.setBadge(tabName, {label: ordersAmount, color: 'primary'});
    }, [ordersAmount, tabName, tabsContext]);

    useEffect(() => {
        if (!hasBeenShown && tabName && tabsContext && tabsContext.isActiveTab(location, tabName)) {
            setHasBeenShown(true);
        }
    }, [hasBeenShown, location, tabName, tabsContext]);

    return <>
        {hasBeenShown ? <OrdersLoader {...props}/> : null}
    </>;
}
